import { FC } from 'react';

import {
  Select,
  SelectProps,
  Option,
} from '@beeline/design-system-react/extracted-styles';

export type DurationSelectProps = Omit<
  SelectProps<Option<string>>,
  | 'label'
  | 'size'
  | 'fullWidth'
  | 'placeholder'
  | 'noOptionsText'
  | 'options'
  | 'loading'
  | 'renderValue'
  | 'multiple'
>;
const renderValue = (options: Option<string>[]): string =>
  options[0]?.value ?? '';

const options: Option<string>[] = [
  { id: 15, value: '15 минут' },
  { id: 30, value: '30 минут' },
  { id: 45, value: '45 минут' },
  { id: 60, value: '1 час' },
  { id: 90, value: '1.5 часа' },
  { id: 120, value: '2 часа' },
  { id: 180, value: '3 часа' },
];

export const defaultDuration = options[1];

export const DurationSelect: FC<DurationSelectProps> = props => {
  return (
    <Select
      {...props}
      size='medium'
      label='Длительность интервала'
      fullWidth
      placeholder='выберите длительность интервала'
      noOptionsText='нет данных'
      options={options}
      renderValue={renderValue}
      multiple={false}
    />
  );
};
